import React from "react";
import { Link } from "react-router-dom";
import { useGetCommentCountQuery } from "../api/artOfTheDayApi";

/**
 * What a signed-out visitor sees where the comments would be. The AOTD page
 * is public, comments are for members: the backend answers a signed-out
 * request with the count only.
 */
export const SignedOutComments: React.FC<{ aotdId: string }> = ({ aotdId }) => {
  const { data: total } = useGetCommentCountQuery(aotdId);
  const lead =
    typeof total === "number" && total > 0
      ? `${total} comment${total === 1 ? "" : "s"} on this one. `
      : "Comments are for members. ";

  return (
    <p style={{ margin: 0, fontSize: "0.85rem", color: "#555", textAlign: "center" }}>
      {lead}
      <Link to="/login">Log in</Link> or <Link to="/register">sign up</Link> to read them and
      add yours.
    </p>
  );
};

export default SignedOutComments;
